import type { IWarehouse } from '@nova/core';
import type { MessagingType } from '@/composables/useCheckinFlow';

export interface MessagingSettings {
  messagingType: MessagingType;
  isSMSEnabled: boolean;
  isWhatsAppEnabled: boolean;
}

export function resolveMessagingSettings(warehouse: Partial<IWarehouse>): MessagingSettings {
  const country = warehouse.country || 'USA';
  const messagingType: MessagingType = ['USA', 'CAN'].includes(country) ? 'SMS' : 'WhatsApp';

  return {
    messagingType,
    isSMSEnabled: messagingType === 'SMS',
    isWhatsAppEnabled: messagingType === 'WhatsApp'
  };
}
